function getPath (t, e, l, n, r) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++) t = t ? t[e[n]] : r;

  return t === r ? l : t;
}

function pluralize (n) {
  var s = String(n).split('.'),
      v0 = !s[1];
  return n == 1 && v0 ? 'one' : 'other';
}

function first(arr, fn) {
  for (var i = 0; i < arr.length; i += 1) {
    var v = fn(arr[i]);
    if (v !== undefined) return v;
  }

  return undefined;
}

function has(o, p) {
  return o && Object.prototype.hasOwnProperty.call(o, p);
}

var Translator = /*#__PURE__*/function () {
  function Translator(strings, options) {
    if (options === void 0) {
      options = {};
    }

    this.strings = strings;
    this.t = this.t.bind(this);
    this.plural = options.plural || pluralize;
    this["default"] = options["default"];
  }

  var _proto = Translator.prototype;

  _proto.parts = function parts(key, data, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    if (Array.isArray(key)) {
      return first(key, function (k) {
        return _this.parts(k, data, {
          "throw": false
        });
      });
    }

    var plural = has(data, 'count') ? this.plural(data.count) : 'one';
    var pluralKeys = [];
    if (plural === 'other') pluralKeys.push(key + "_plural");
    pluralKeys.push(key + "_" + plural);
    if (plural === 'one') pluralKeys.push(key);
    var template = first(pluralKeys, function (k) {
      return getPath(_this.strings, k);
    });

    if (template === undefined) {
      if (this["default"]) return this["default"].parts(key, data, options);

      if (options && options["throw"] === false) {
        return undefined;
      }

      throw new Error("@u-wave/translate: Key \"" + key + "\" does not exist.");
    }

    return template.split(/\{\{(.*?)\}\}/).map(function (part, i) {
      if (i % 2) return getPath(data, part);
      return part;
    }, []);
  };

  _proto.t = function t(key, data) {
    var arr = this.parts(key, data);
    return arr.join('');
  };

  return Translator;
}();

export default Translator;
